export const urlGroupsSearch = '/api/search/group';
export const urlRoles = '/api/groups/get-suggest-by-role-name';
export const urlGroupCode = '/api/groups/get-suggest-by-group-code';
export const urlUserName = '/api/groups/get-suggest-by-user-name';
export const urlGroups = '/api/groups';
